import { graphql } from "@/lib/gql/__generated__";

export const SnackDelete_SnackListPage_Mutation = graphql(`
	mutation SnackDelete_SnackListPage($hotelID: ID!, $uuid: ID!) {
		snackDelete(hotelID: $hotelID, uuid: $uuid) {
			userErrors
			message
			uuid
		}
	}
`);
